namespace RioERP.Web.Enums {
    export enum WhatsAppEvent {
        Approved = 1
    }
    Serenity.Decorators.registerEnumType(WhatsAppEvent, 'RioERP.Web.Enums.WhatsAppEvent');
}
